import { apiFetch } from './api';

export type Plano = {
  id: string;
  nome: string;
  descricao: string;
  maxUsuarios: number;
  maxSalas: number;
  maxCirurgiasAoVivo: number;
  maxStorageGB: number;
  maxRetencaoDias: number;
  featuresJson: string;
  precoCentavosMes: number;
  ativo: boolean;
};

export type LicenseInfo = {
  id: string;
  hospitalId: string;
  planoId: string;
  planoNome: string;
  validaDe: string;
  validaAte: string;
  status: 'Ativa' | 'Expirada' | 'Suspensa' | 'Cancelada';
  ativadaEm: string | null;
  diasRestantes: number;
  uso: { usuarios: number; salas: number; cirurgiasAoVivo: number };
  limites: {
    usuarios: number;
    salas: number;
    cirurgiasAoVivo: number;
    storageGB: number;
    retencaoDias: number;
  };
};

export const listPlans = () => apiFetch<Plano[]>('/plans');

export const getLicense = (hospitalId?: string) =>
  apiFetch<LicenseInfo>(
    `/license${hospitalId ? `?hospitalId=${hospitalId}` : ''}`,
  );

export const activateLicense = (data: {
  hospitalId: string;
  planoId: string;
  validaDe: string;
  validaAte: string;
  observacoes?: string;
}) => apiFetch<void>('/license/activate', { method: 'POST', body: JSON.stringify(data) });
